var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLocator = function SvgIconLocator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.59c0 3.015-2.017 6.247-4.134 8.789a36.566 36.566 0 0 1-3.83 3.932l-.036.03-.036-.03a36.562 36.562 0 0 1-3.83-3.932C6.017 14.837 4 11.605 4 8.59c0-1.705.871-3.478 2.33-4.834C7.785 2.406 9.79 1.5 12 1.5s4.215.906 5.67 2.257C19.129 5.113 20 6.886 20 8.591Z",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 3.5,
    stroke: "currentColor"
  })));
};
export default SvgIconLocator;